import { render } from "./RewardStockWarning.vue?vue&type=template&id=5b4b2eda&scoped=true"
import script from "./RewardStockWarning.vue?vue&type=script&lang=js"
export * from "./RewardStockWarning.vue?vue&type=script&lang=js"

import "./RewardStockWarning.vue?vue&type=style&index=0&id=5b4b2eda&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4b2eda"]])

export default __exports__